module.exports = __webpack_public_path__ + "static/media/19.b8db9031.jpg";